import { styled } from "@mui/material/styles";

export const DefaultList = styled('ul')(() => ({
	paddingLeft: 30,
	'& li': {
		marginBottom: '25px'
	}
}))
